import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardContent, CardFooter } from "./card";
import { Button } from "./button";
import { Badge } from "./badge";
import { Avatar } from "./avatar"; 
import { formatDate } from "../../lib/utils";
import { Download, Users, ExternalLink } from "lucide-react";
import { cn } from "../../lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";

export function LeadCard({ data, handleDownload }) {
  const navigate = useNavigate();

  // Format the date
  const formattedDate = data?.date ? formatDate(data.date) : "";

  // Get status color
  const getStatusColor = (status) => {
    switch(status) {
      case 'ACTIVE':
        return "bg-green-100 text-green-700 hover:bg-green-200";
      case 'PAUSED':
        return "bg-orange-100 text-orange-700 hover:bg-orange-200";
      default:
        return "bg-primary/10 text-primary hover:bg-primary/20";
    }
  };

  return (
    <Card className="w-full overflow-hidden transition-all hover:shadow-md">
      <CardHeader className="p-4 pb-2 flex flex-row items-start justify-between gap-2">
        <div className="space-y-1">
          <h3 className="font-semibold text-lg leading-none truncate max-w-[200px]" title={data?.name}>
            {data?.name}
          </h3>
          <p className="text-xs text-muted-foreground">{formattedDate}</p>
        </div>
        <Badge variant="outline" className={cn("ml-auto", getStatusColor(data?.status))}>
          {data?.status}
        </Badge>
      </CardHeader>
      <CardContent className="p-4 pt-2">
        <div className="flex items-center gap-2">
          <Avatar className="h-8 w-8 bg-primary/10">
            <Users className="h-4 w-4 text-primary" />
          </Avatar>
          <div>
            <p className="text-xs text-muted-foreground">Leads</p>
            <p className="font-medium">{data?.leads_count || 0}</p>
          </div>
        </div>
        
        <div className="flex items-center mt-3 gap-1">
          <img src="socialIcons/fbLogo.svg" alt="facebook" className="h-5 w-5" />
          <img src="socialIcons/instagram.png" alt="instagram" className="h-4 w-4" />
          <img src="socialIcons/googleLogo.svg" alt="google" className="h-5 w-5" />
        </div>
      </CardContent>
      <CardFooter className="p-4 pt-0 flex justify-between">
        {data?.sheet?.url ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(data.sheet.url, '_blank');
                  }}
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  Google Sheet
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Open in Google Sheets</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <Button variant="ghost" size="sm" disabled>
            <ExternalLink className="h-4 w-4 mr-2" />
            Google Sheet
          </Button>
        )}
        
        <Button 
          variant="outline" 
          size="sm"
          onClick={() => navigate(`/leads`, { state: data?.campaign_id })}
        >
          View Leads
        </Button>
      </CardFooter>
    </Card>
  );
} 